import { gql } from 'apollo-angular';

export const GetCanvasCategoryDocument = gql`
  query getCanvasCategory($id: Int!) {
    getCanvasCategory(id: $id) {
      id
      name
      description
    }
  }
`;
